// src/config/plans.js
// Central source of truth for plan tiers and what each tier unlocks.
// Backend should return `plan` ('free' | 'growth' | 'enterprise') as
// part of the login response / session — see notes at the bottom.

export const PLAN_ORDER = ['free', 'growth', 'enterprise'];

export const PLAN_LABELS = {
  free: 'Free',
  growth: 'Growth',
  enterprise: 'Enterprise',
};

export const PLAN_PRICE_LABEL = {
  free: '₹0',
  growth: '₹4,999/mo · up to 10 users',
  enterprise: 'Custom pricing',
};

// Feature key → minimum plan required to use it.
// Keep this flat and boring — one line per gated capability.
export const FEATURE_MIN_PLAN = {
  visits_expenses:        'growth',
  tasks:                  'growth',
  call_records:           'growth',
  followups:               'growth',
  reports:                 'growth',
  ocr:                     'growth',
  company_branding_edit:   'growth',
  multi_level_approval:    'growth',
  multi_branch:            'enterprise',
  reports_export:          'enterprise',
  white_label:             'enterprise',
  inbound_leads:            'enterprise',
  lead_intake_report:       'enterprise',
  lead_intake_report:            'enterprise',
  
};

// Simple usage caps (enforced server-side too — this is just for
// showing "X of Y used" in the UI before the request even goes out).
export const PLAN_LIMITS = {
  free:       { users: 2,  quotesPerMonth: 25,  ocrScansPerMonth: 0 },
  growth:     { users: 10, quotesPerMonth: Infinity, ocrScansPerMonth: 100 },
  enterprise: { users: Infinity, quotesPerMonth: Infinity, ocrScansPerMonth: Infinity },
};

export const planAtLeast = (userPlan, requiredPlan) => {
  const have = PLAN_ORDER.indexOf(userPlan || 'free');
  const need = PLAN_ORDER.indexOf(requiredPlan);
  return have >= need;
};

export const planForFeature = (userPlan, featureKey) =>
  planAtLeast(userPlan, FEATURE_MIN_PLAN[featureKey] || 'free');

// ─────────────────────────────────────────────────────────────
// BACKEND NOTE:
// login() in quotationB.php currently selects id/corp_id/ryts/name/email.
// Add `plan` to that select (from the `corp` table — you already have
// a `plans` column showing up as null in your getCompanySettings
// response) and include it in the !@#$-delimited response string, or
// switch login to return JSON so adding fields doesn't require touching
// the delimiter-parsing logic in api.js's Auth.login().
// ─────────────────────────────────────────────────────────────
